<template>
  <div class="avatar-uploader text-center">
    <div class="flex flex-col items-center gap-2 cursor-pointer">
      <ProgressContainer :percent="uploadPercent">
        <div class="relative" :style="aspectStyle">
          <div v-if="imageUrl" class="relative w-full h-full">
            <img
              :src="imageUrl"
              class="avatar w-full h-full object-cover rounded"
              :class="[{ 'cursor-pointer': enablePreview }]"
              @click="handlePreview"
            />
            <div
              v-if="clearable"
              class="absolute size-8 top-0 right-0 p-1 cursor-pointer bg-[rgba(0,0,0,0.5)] rounded-full"
              @click.stop="handleClear"
            >
              <i
                class="el-icon-close"
                style="color: white; font-size: 20px"
              ></i>
            </div>
          </div>
          <div
            v-else
            @click="pickFile"
            class="flex flex-col justify-center items-center w-full h-full flex-none rounded bg-gray-300"
          >
            <i class="el-icon-camera text-black text-2xl"></i>
          </div>
        </div>
      </ProgressContainer>
      <span>
        <el-button
          :loading="uploading"
          @click="pickFile"
          type="primary"
          icon="el-camera"
          >Pick Image</el-button
        >
      </span>
      <input
        type="file"
        accept="image/*"
        class="hidden"
        @change="handleAvatarChange"
        ref="fileInputRef"
      />
    </div>
  </div>
</template>

<script>
import { uploadFileToAgentServer } from "@/api";
import ProgressContainer from "./ProgressContainer.vue";
// 如有裁剪/预览功能请确保相关组件和API已实现
export default {
  components: { ProgressContainer },
  name: "AvatarUploader",
  props: {
    value: String,
    aspectRatio: {
      type: String,
      default: "1/1",
    },
    maxSize: {
      type: Number,
      default: 5 * 1024 * 1024,
    },
    enableCrop: {
      type: Boolean,
      default: true,
    },
    enablePreview: {
      type: Boolean,
      default: true,
    },
    clearable: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      imageUrl: this.value,
      uploading: false,
      uploadPercent: null,
    };
  },
  computed: {
    aspectStyle() {
      return {
        aspectRatio: this.aspectRatio,
        width: "6rem",
        height: "auto",
        maxHeight: "24rem",
        minHeight: "6rem",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      };
    },
  },
  watch: {
    value(newVal) {
      this.imageUrl = newVal;
    },
  },
  methods: {
    pickFile() {
      this.$refs.fileInputRef.click();
    },
    async handleAvatarChange(evt) {
      const file = evt.target.files[0];
      if (!file) return;
      // 文件大小限制
      if (file.size > this.maxSize) {
        this.$message.error(
          `File size exceeds the limit (${Math.round(
            this.maxSize / 1024 / 1024
          )}MB)`
        );
        return;
      }
      let finalFile = file;
      // Crop functionality (if implemented)
      if (this.enableCrop && this.$imageCropper) {
        const croppedBlob = await this.$imageCropper.open({
          file,
          aspectRatio: this.aspectRatio,
        });
        if (!croppedBlob) {
          this.uploading = false;
          return;
        }
        finalFile = new File([croppedBlob], file.name, { type: file.type });
      }
      try {
        this.uploading = true;
        this.uploadPercent = 0;
        this.imageUrl = URL.createObjectURL(finalFile);
        const response = await uploadFileToAgentServer(finalFile, (e) => {
          if (e && e.total) {
            this.uploadPercent = Math.round((e.loaded / e.total) * 100);
          }
        });
        this.$emit("input", response.url);
        this.uploadPercent = null;
      } catch (e) {
        this.$message.error("Upload failed: " + e.message);
        this.uploadPercent = null;
      } finally {
        this.uploading = false;
      }
    },
    async handlePreview() {
      if (this.value && this.enablePreview && this.$imagePreviewer) {
        await this.$imagePreviewer([this.value]);
      }
    },
    async handleClear() {
      if (this.clearable) {
        await this.$confirm(
          "Are you sure you want to clear the avatar?",
          "Warning",
          {
            confirmButtonText: "Yes",
            cancelButtonText: "No",
            type: "warning",
          }
        );
        this.$emit("input", "");
      }
    },
  },
};
</script>
